import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/lib/site";

const QuizCTA = () => (
  <section
    id="quiz"
    data-testid="quiz-section"
    className="bg-accent px-6 py-24 md:px-12 md:py-32"
  >
    <div className="mx-auto max-w-[1400px]">
      <Reveal>
        <div className="flex items-center gap-3 text-accent-foreground/80">
          <Sparkles size={20} />
          <span className="text-xs font-bold uppercase tracking-[0.22em]">
            Free · 12 Questions · 2 Minutes
          </span>
        </div>
        <div className="mt-8 flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
          <h2 className="max-w-3xl font-display text-5xl font-medium leading-[0.98] tracking-tightest text-accent-foreground md:text-7xl">
            What's Your <span className="italic">Money Personality?</span>
          </h2>
          <Link to={SITE.quiz} data-testid="quiz-cta-btn">
            <motion.span
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.98 }}
              className="group flex items-center gap-3 whitespace-nowrap rounded-full bg-background px-9 py-5 text-base font-semibold text-primary"
            >
              Take the Quiz
              <ArrowUpRight
                size={20}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </motion.span>
          </Link>
        </div>
        <p className="mt-8 max-w-2xl text-lg font-light text-accent-foreground/85">
          A 12-entry passbook covering how you spend, what you know about interest,
          risk and emergencies, and how you feel about money day to day. Leave with your
          Money Personality and a Financial Well-Being Check out of 10 — anonymous, no
          sign-up needed.
        </p>
      </Reveal>
    </div>
  </section>
);

export default QuizCTA;
